<template>
  <div class="vtl">
    <div v-if="model.name !== 'root'">
      <div
        v-if="childIndex === 0"
        class="vtl-border vtl-up"
        :class="{ 'vtl-active': isDragEnterUp }"
        @drop="dropBefore"
        @dragenter="dragEnterUp"
        @dragover="dragOverUp"
        @dragleave="dragLeaveUp"
      />
      <div
        :id="model.id"
        style="position: relative"
        :class="treeNodeClass"
        :draggable="!model.dragDisabled"
        @dragstart="dragStart"
        @dragover="dragOver"
        @dragenter="dragEnter"
        @dragleave="dragLeave"
        @drop="drop"
        @dragend="dragEnd"
        @mouseover="mouseOver"
        @mouseout="mouseOut"
        @click.stop="click"
      >
        <span
          v-if="model.children && model.children.length > 0"
          class="vtl-caret vtl-is-small"
        >
          <i
            class="vtl-icon"
            :class="caretClass"
            @click.prevent.stop="toggle"
          />
        </span>

        <div class="vtl-node-content">
          <b>{{ model.evaluation_administrator_node_nomenclature }}</b>
          {{ model.evaluation_administrator_node_requirementName }}
        </div>

        <div v-show="isHover && editMode" class="vtl-operation">
          <span
            v-if="!model.isLeaf && !model.addTreeNodeDisabled"
            title="add tree node"
            @click.stop.prevent="addChild()"
          >
            <slot name="addTreeNodeIcon">
              <i class="vtl-icon vtl-icon-folder-plus-e" />
            </slot>
          </span>
          <span title="edit" @click.stop.prevent="setEditable">
            <slot name="editNodeIcon">
              <i class="vtl-icon vtl-icon-edit" />
            </slot>
          </span>
          <span
            v-if="!model.children || model.children == 0"
            title="delete"
            @click.stop.prevent="showModalF"
          >
            <slot name="delNodeIcon">
              <i class="vtl-icon vtl-icon-trash" />
            </slot>
          </span>
        </div>

        <div style="position: absolute; right: 0px">
          {{ model.evaluation_administrator_node_percentualWeight }} %
        </div>
        <div class="break" />
        <!-- break -->
        <div v-if="!model.children || model.children == 0" class="options">
          <span
            v-if="editMode"
            class="edit"
            @click.stop.prevent="setEditable"
            >{{
              $t("label_evaluation_administrator_node_matrix_editDetails")
            }}</span
          >
          <span
            v-if="!editMode"
            class="edit"
            @click.stop.prevent="setEditable"
            >{{
              $t("label_evaluation_administrator_node_matrix_viewDetails")
            }}</span
          >
          <span
            v-if="
              typeof model.evaluation_administrator_node_editRequirement_requireEvidences !=
                'undefined' &&
              model.evaluation_administrator_node_editRequirement_requireEvidences !=
                null
            "
          >
            {{ $t("label_evaluation_administrator_node_matrix_evidence") }}
            {{
              model.evaluation_administrator_node_editRequirement_requireEvidences
                ? $t("label_evaluation_administrator_node_matrix_yes")
                : $t("label_evaluation_administrator_node_matrix_no")
            }}
          </span>
          <span v-if="model.evaluation_administrator_node_matrix_indicator">
            {{ $t("label_evaluation_administrator_node_matrix_indicator") }}
            {{ model.evaluation_administrator_node_matrix_indicator }}
          </span>
        </div>
      </div>
    </div>

    <div
      v-show="model.name === 'root' || expanded"
      v-if="isFolder"
      :class="{ 'vtl-tree-margin': model.name !== 'root' }"
    >
      <evaluation-models-requirements-tree-list
        v-for="(model, index) in model.children"
        :key="model.id"
        :default-tree-node-name="defaultTreeNodeName"
        :default-leaf-node-name="defaultLeafNodeName"
        :default-expanded="defaultExpanded"
        :last-created="lastCreated"
        :edit-mode="editMode"
        :model="model"
        :child-index="index"
      >
        <slot slot="addTreeNodeIcon" name="addTreeNodeIcon" />
        <slot slot="addLeafNodeIcon" name="addLeafNodeIcon" />
        <slot slot="editNodeIcon" name="editNodeIcon" />
        <slot slot="delNodeIcon" name="delNodeIcon" />
        <slot slot="treeNodeIcon" name="treeNodeIcon" />
      </evaluation-models-requirements-tree-list>
    </div>
    <!--v-if="model.children && model.children.length > 0 && expanded"-->
    <div
      v-if="model.name !== 'root'"
      class="vtl-border vtl-bottom"
      :class="{ 'vtl-active': isDragEnterBottom }"
      @drop="dropAfter"
      @dragenter="dragEnterBottom"
      @dragover="dragOverBottom"
      @dragleave="dragLeaveBottom"
    />
    <b-modal
      id="modalInfo"
      v-model="showModal"
      modal-class="modalInfo"
      :title="'Delete '"
    >
      {{ $t("label_evaluation_delete_message") }}
      <b> {{ model.evaluation_administrator_node_requirementName }}</b>
      <div slot="modal-footer" class="w-100" style="text-align: right">
        <b-btn variant="primary" @click="hideModal()">
          {{ $t("label_evaluation_cancel_button") }}
        </b-btn>
        <b-btn variant="primary" @click="delNode()">
          {{ $t("label_evaluation_delete_button") }}
        </b-btn>
      </div>
    </b-modal>
  </div>
</template>
<script >
import {
  addHandler,
  removeHandler,
} from "../../../../utils/vue-tree-list/tools";
let compInOperation = null;
export default {
  name: "EvaluationModelsRequirementsTreeList",
  props: {
    model: {
      type: Object,
    },
    editMode: {
      type: Boolean,
    },
    defaultLeafNodeName: {
      type: String,
      default: "New leaf node",
    },
    defaultTreeNodeName: {
      type: String,
      default: "New tree node",
    },
    defaultExpanded: {
      type: Boolean,
      default: false,
    },
    lastCreated: {
      type: Number,
      default: -1,
    },
    childIndex: {
      type: Number,
      default: 0,
    },
  },
  data: function () {
    return {
      isHover: false,
      editable: false,
      isDragEnterUp: false,
      isDragEnterBottom: false,
      isDragEnterNode: false,
      expanded: this.defaultExpanded,
      showModal: false,
    };
  },
  computed: {
    itemIconClass() {
      return this.model.isLeaf ? "vtl-icon-file" : "vtl-icon-folder";
    },
    caretClass() {
      return this.expanded ? "vtl-icon-caret-down" : "vtl-icon-caret-right";
    },

    isFolder() {
      return this.model.children && this.model.children.length;
    },

    treeNodeClass() {
      const {
        model: { dragDisabled, disabled },
        isDragEnterNode,
      } = this;

      return {
        "vtl-tree-node": true,
        "vtl-active": isDragEnterNode,
        "vtl-drag-disabled": dragDisabled,
        "vtl-disabled": disabled,
      };
    },
  },
  watch: {
    lastCreated: function () {
      this.expanded = this.lastCreatedInChildren(this.model);
    },
  },
  mounted() {
    const vm = this;
    addHandler(window, "keyup", function (e) {
      // click enter
      if (e.keyCode === 13 && vm.editable) {
        vm.editable = false;
      }
    });
    this.expanded = this.lastCreatedInChildren(this.model);
  },
  beforeDestroy() {
    removeHandler(window, "keyup");
  },
  methods: {
    lastCreatedInChildren(node) {
      let shouldExpand = false;
      if (node.children && node.children.length > 0) {
        node.children.map((child) => {
          if (child.children && child.children.length > 0) {
            shouldExpand = shouldExpand || this.lastCreatedInChildren(child);
          } else {
            if (child.id === this.lastCreated) {
              shouldExpand = true;
            }
          }
        });
      }
      return shouldExpand;
    },
    showModalF() {
      this.showModal = true;
    },
    hideModal() {
      this.showModal = false;
    },
    updateName(e) {
      var oldName = this.model.name;
      this.model.changeName(e.target.value);
      var node = this.getRootNode();
      node.$emit("change-name", {
        id: this.model.id,
        oldName: oldName,
        newName: e.target.value,
      });
    },

    delNode() {
      var node = this.getRootNode();
      this.model.remove();
      node.$emit("delete-node");
    },

    setEditable() {
      /*        this.editable = true
        this.$nextTick(() => {
          const $input = this.$refs.nodeInput
          $input.focus()
          $input.setSelectionRange(0, $input.value.length)
        })*/
      var root = this.getRootNode();
      root.$emit("add-node", this.model, true);
    },

    setUnEditable() {
      this.editable = false;
    },

    toggle() {
      if (this.isFolder) {
        this.expanded = !this.expanded;
      }
    },

    mouseOver() {
      if (this.model.disabled) {
        return;
      }
      this.isHover = true;
    },

    mouseOut() {
      this.isHover = false;
    },

    click() {
      var node = this.getRootNode();
      node.$emit("click", this.model);
    },

    addChild() {
      /*        const name = isLeaf ? this.defaultLeafNodeName : this.defaultTreeNodeName
        this.expanded = true
        var node = new TreeNode({ name, isLeaf })
        this.model.addChildren(node, true)*/
      var root = this.getRootNode();
      this.expanded = true;
      root.$emit("add-node", this.model, false);
    },

    dragStart(e) {
      if (!(this.model.dragDisabled || this.model.disabled)) {
        compInOperation = this;
        // for firefox
        e.dataTransfer.setData("data", "data");
        e.dataTransfer.effectAllowed = "move";
        return true;
      }
      return false;
    },
    dragEnd() {
      compInOperation = null;
    },
    dragOver(e) {
      e.preventDefault();
      return true;
    },
    dragEnter() {
      if (!compInOperation) {
        return;
      }
      if (this.model.isLeaf) {
        return;
      }
      this.isDragEnterNode = true;
    },
    dragLeave() {
      this.isDragEnterNode = false;
    },
    drop() {
      if (!compInOperation) {
        return;
      }
      const oldParent = compInOperation.model.parent;
      compInOperation.model.moveInto(this.model);
      this.isDragEnterNode = false;
      var node = this.getRootNode();
      node.$emit("drop", {
        target: this.model,
        node: compInOperation.model,
        src: oldParent,
      });
    },

    dragEnterUp() {
      if (!compInOperation) {
        return;
      }
      this.isDragEnterUp = true;
    },
    dragOverUp(e) {
      e.preventDefault();
      return true;
    },
    dragLeaveUp() {
      if (!compInOperation) {
        return;
      }
      this.isDragEnterUp = false;
    },
    dropBefore() {
      if (!compInOperation) {
        return;
      }
      const oldParent = compInOperation.model.parent;
      compInOperation.model.insertBefore(this.model);
      this.isDragEnterUp = false;
      var node = this.getRootNode();
      node.$emit("drop-before", {
        target: this.model,
        node: compInOperation.model,
        src: oldParent,
      });
    },

    dragEnterBottom() {
      if (!compInOperation) {
        return;
      }
      this.isDragEnterBottom = true;
    },
    dragOverBottom(e) {
      e.preventDefault();
      return true;
    },
    dragLeaveBottom() {
      if (!compInOperation) {
        return;
      }
      this.isDragEnterBottom = false;
    },
    dropAfter() {
      if (!compInOperation) {
        return;
      }
      const oldParent = compInOperation.model.parent;
      compInOperation.model.insertAfter(this.model);
      this.isDragEnterBottom = false;
      var node = this.getRootNode();
      node.$emit("drop-after", {
        target: this.model,
        node: compInOperation.model,
        src: oldParent,
      });
    },
    getRootNode() {
      var node = this.$parent;
      while (node._props.model.name !== "root") {
        node = node.$parent;
      }
      return node;
    },
  },
};
</script>
<style lang="scss" scoped>
h4 {
  font-size: 1.3rem;
  text-transform: uppercase;
}
@font-face {
  font-family: "icomoon";
  src: url("../../../../utils/vue-tree-list/fonts/icomoon.eot");
  src: url("../../../../utils/vue-tree-list/fonts/icomoon.eot")
      format("embedded-opentype"),
    url("../../../../utils/vue-tree-list/fonts/icomoon.ttf") format("truetype"),
    url("../../../../utils/vue-tree-list/fonts/icomoon.woff") format("woff"),
    url("../../../../utils/vue-tree-list/fonts/icomoon.svg") format("svg");
  font-weight: normal;
  font-style: normal;
}
.vtl-icon {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "icomoon" !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  &.vtl-menu-icon {
    margin-right: 4px;
    &:hover {
      color: inherit;
    }
  }
  &:hover {
    color: blue;
  }
}

.vtl-icon-file:before {
  content: "\e906";
}
.vtl-icon-folder:before {
  content: "\e907";
}
.vtl-icon-caret-down:before {
  content: "\e901";
}
.vtl-icon-caret-right:before {
  content: "\e900";
}
.vtl-icon-edit:before {
  content: "\e902";
}
.vtl-icon-folder-plus-e:before {
  content: "\e903";
}
.vtl-icon-plus:before {
  content: "\e904";
}
.vtl-icon-trash:before {
  content: "\e905";
}

.vtl-border {
  height: 20px;
  &.vtl-up {
    margin-top: -5px;
  }
  &.vtl-bottom {
  }
  &.vtl-active {
    border: 3px dashed blue;
    /*background-color: blue;*/
  }
}

.vtl-tree-node {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 5px 0 5px 1rem;
  .vtl-input {
    border: none;
    max-width: 150px;
    border-bottom: 1px solid blue;
  }
  &:hover {
    background-color: #f0f0f0;
    cursor: -webkit-grab; cursor: grab;
  }
  &.vtl-active {
    outline: 2px dashed pink;
  }
  .vtl-caret {
    margin-left: -1rem;
  }
  .vtl-operation {
    margin-left: 2rem;
    letter-spacing: 1px;
  }
}

.vtl-item {
  cursor: pointer;
}
.vtl-tree-margin {
  margin-left: 2em;
}
.break {
  flex-basis: 100%;
  height: 0;
}

.options {
  font-size: 12px;
  font-style: italic;
  .edit {
    color: #0c3a9b;
  }
}
.vtl-node-content {
  padding-right: 45px;
}
</style>

<style lang="scss" scoped>
.vtl-border {
  height: 20px;
  &.vtl-up {
    margin-top: -5px;
    border: 1px dashed #b6b6b6;
  }
  &.vtl-bottom {
    border: 1px dashed #b6b6b6;
  }
  &.vtl-active {
    border: 3px dashed blue;
    /*background-color: blue;*/
  }
}
</style>
